import React from 'react';
import './App.css';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import CssBaseline from '@mui/material/CssBaseline';
import SignUp from './containers/SignUp';
import { PrivateRoutes } from './PrivateRoutes';
import SignIn from './containers/SignIn';
import mfTheme from './themes/MfTheme';
import CreateRequestPage from './pages/CreateRequestPage';
import InfoPage from './pages/InfoPage';
import RequestListPage from './pages/RequestListPage';
import ProfilePage from './pages/ProfilePage';
import AccountProvider from './context/AccountProvider';
import EmailConfirm from './containers/EmailConfirm';
import SocketProvider from './context/SocketProvider';

function App() {
  const theme = createTheme(mfTheme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        autoHideDuration={null}
        preventDuplicate
        maxSnack={10}
        style={{ pointerEvents: 'all' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <AccountProvider>
          <SocketProvider>
            <Router>
              <Routes>
                <Route element={<PrivateRoutes />}>
                  <Route path="/" element={<RequestListPage />} />
                  <Route
                    path="/create-request"
                    element={<CreateRequestPage />}
                  />
                  <Route path="/info" element={<InfoPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                </Route>
                <Route path="/signUp" element={<SignUp />} />
                <Route path="/signIn" element={<SignIn />} />
                <Route path="/emailConfirm/:token" element={<EmailConfirm />} />
              </Routes>
            </Router>
          </SocketProvider>
        </AccountProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
